import axios from 'axios'

let client = ''
const pathname = window.location.pathname.split('/')
if (pathname.length > 1) {  client = pathname[1]}

let api_url = process.env.REACT_APP_API_URL

let baseURL
if (api_url) {
  baseURL = `${api_url}/${client}/api`
} else {
  baseURL = `${window.location.origin}/backend/${client}/api`
}


const axiosApi = axios.create({
  baseURL: baseURL
})

axiosApi.interceptors.request.use(
  config => {
    config.headers['X-API-ENDPOINT'] = 1;
        return config;
    }
);

axiosApi.interceptors.response.use((response) => response, (error) => {
  // if not authenticated, reroute to login
  const pathname = window.location.pathname.split('/')
  let client = ''
  if (pathname.length > 1) {  client = pathname[1]}
  if (error?.response?.status === 401) {
    if (window.location.pathname !== `/${client}` && !window.location.pathname.startsWith(`/${client}/reset-password`)) {
        window.location.replace(`/${client}`);
    }
    return false;
  } else {
    return Promise.reject(error);
  }
})

export { axiosApi }
